import React, { useEffect, useState } from 'react';
import css from './ContactInformation.module.css';
import {
  EmailField,
  PhoneField,
  StackedColumn,
  StackedColumnSpacing,
  TextField,
  TextLink,
  ZipField,
} from '../../../../../core';
import { ContactDetails } from '../../../../../api/models';
import { StateDropdownField } from './stateDropdownField';

export interface DemographicsDisplayProps {
  contactDetails: ContactDetails;
  validate: boolean;
  onContactInfoChanged: (contactDetails: ContactDetails) => void;
}

const DemographicsDisplay: React.FC<DemographicsDisplayProps> = (
  props: DemographicsDisplayProps
) => {
  const [showAdditionalLine, setShowAdditionalLine] = useState<boolean>(false);
  const [contactDetails, setContactDetails] = useState<ContactDetails>(
    props.contactDetails
  );

  useEffect(() => {
    setContactDetails(props.contactDetails);
  }, [props.contactDetails]);

  const onContactDetailsChanged = (contactDetails: ContactDetails) => {
    setContactDetails(contactDetails);
    props.onContactInfoChanged(contactDetails);
  };

  const onAddAdditionalAddressLine = () => {
    setShowAdditionalLine(true);
  };

  return (
    <StackedColumn spacing={StackedColumnSpacing.Wide}>
      <StackedColumn spacing={StackedColumnSpacing.NoGap}>
        <TextField
          value={contactDetails.mailingAddress}
          label="Mailing address"
          required={true}
          validate={props.validate}
          onChange={(value) =>
            onContactDetailsChanged({
              ...contactDetails,
              ['mailingAddress']: value,
            })
          }
        />
        {showAdditionalLine === false ? (
          <>
            <TextLink
              caption="Add Apt #, Suite, Floor (Optional)"
              onClick={() => onAddAdditionalAddressLine()}
            />
          </>
        ) : null}
      </StackedColumn>
      {showAdditionalLine ? (
        <TextField
          value={contactDetails.additionalAddress}
          label="Apt #, Suite, Floor (Optional)"
          required={false}
          validate={props.validate}
          onChange={(value) =>
            onContactDetailsChanged({
              ...contactDetails,
              ['additionalAddress']: value,
            })
          }
        />
      ) : null}
      <TextField
        value={contactDetails.city}
        label="City"
        required={true}
        validate={props.validate}
        onChange={(value) =>
          onContactDetailsChanged({
            ...contactDetails,
            ['city']: value,
          })
        }
      />

      <StateDropdownField
        selectedState={contactDetails.state}
        required={true}
        validate={props.validate}
        onSelectionChanged={(value) =>
          onContactDetailsChanged({
            ...contactDetails,
            ['state']: value,
          })
        }
      />
      <div className={css.smallField}>
        <ZipField
          value={contactDetails.zip}
          label="Zip"
          required={true}
          validate={props.validate}
          onChange={(value) =>
            onContactDetailsChanged({
              ...contactDetails,
              ['zip']: value,
            })
          }
        />
      </div>
      <PhoneField
        value={contactDetails.phoneNumber}
        label="Phone number"
        required={true}
        validate={props.validate}
        onChange={(value) =>
          onContactDetailsChanged({
            ...contactDetails,
            ['phoneNumber']: value,
          })
        }
      />
      <PhoneField
        value={contactDetails.mobileNumber}
        label="Mobile number (optional)"
        required={false}
        validate={props.validate}
        onChange={(value) =>
          onContactDetailsChanged({
            ...contactDetails,
            ['mobileNumber']: value,
          })
        }
      />
      <EmailField
        value={contactDetails.emailAddress}
        label="Email address"
        required={true}
        validate={props.validate}
        onChange={(value) =>
          onContactDetailsChanged({
            ...contactDetails,
            ['emailAddress']: value,
          })
        }
      />
    </StackedColumn>
  );
};

export default DemographicsDisplay;
